import { ArrowRight, Check, Plus } from "lucide-react";
import * as Icons from "lucide-react";
import { useInquiry } from "../context/InquiryContext";

export const ProductCard = ({ product, showBorder = true }) => {
  const { openInquiry, getItemQuantity } = useInquiry();
  const quantityInList = getItemQuantity(product.id || product.name);

  return (
    <article
      className={`group bg-white ${
        showBorder
          ? "border border-slate-200/80 shadow-xs"
          : "border border-slate-100"
      } overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col h-full rounded-none relative`}
    >
      {/* Badge if item is already added to inquiry list */}
      {quantityInList > 0 && (
        <div className="absolute top-2.5 right-2.5 z-10 bg-orange-600 text-white text-[11px] font-bold px-2 py-0.5 shadow-sm flex items-center gap-1">
          <Check size={11} className="stroke-[3]" />
          <span>{quantityInList} i listen</span>
        </div>
      )}

      {/* Product Image */}
      <div className="relative aspect-square w-full overflow-hidden bg-slate-50 border-b border-slate-100">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-105"
          loading="lazy"
        />
      </div>

      {/* Product Info & Caption */}
      <div className="p-4 sm:p-5 text-center flex flex-col flex-1 justify-between">
        <div>
          <h3 className="text-lg sm:text-xl text-slate-900 leading-snug font-semibold">
            {product.name}
          </h3>
          {product.description && (
            <p className="text-xs text-slate-500 mt-1.5 line-clamp-2 leading-relaxed">
              {product.description}
            </p>
          )}
        </div>

        <div className="mt-4 pt-3 border-t border-slate-100 flex flex-col min-[1200px]:flex-row items-center justify-between gap-2.5">
          <span className="text-sm sm:text-base font-bold text-slate-900 font-mono tracking-tight">
            {product.price}
          </span>
          <button
            type="button"
            onClick={() => openInquiry(product)}
            className="w-full min-[1200px]:w-auto justify-center text-xs font-semibold px-3 py-1.5 bg-slate-900 text-white hover:bg-orange-500 transition-colors inline-flex items-center gap-1 cursor-pointer"
          >
            {quantityInList > 0 ? (
              <>
                <Plus size={12} /> Tilføj / Se liste
              </>
            ) : (
              <>
                Forespørg <ArrowRight size={12} />
              </>
            )}
          </button>
        </div>
      </div>
    </article>
  );
};

export const ServiceCard = ({ service }) => {
  const Icon = Icons[service.icon];

  return (
    <div className="p-8 bg-white text-slate-900 border border-slate-100 transition-all shadow-sm hover:shadow-md">
      <div className="w-14 h-14 bg-slate-900 text-white flex items-center justify-center mb-6">
        {Icon && <Icon size={28} />}
      </div>
      <h3 className="text-2xl font-semibold mb-3">{service.title}</h3>
      <p className="text-slate-600 leading-relaxed">
        {service.description}
      </p>
    </div>
  );
};
